/* eslint-disable max-classes-per-file */
import { type QueryFilters as TanstackQueryFilters } from '@tanstack/react-query';
import { QueryType } from 'src/new_arch/queries/types';

class QueryKeys {
	static forProjectMembers( { projectID }: { projectID: number } ) {
		return [ 'projects', projectID, 'members' ];
	}

	static forProjectInvitations( { projectID }: { projectID: number } ) {
		return [ 'projects', projectID, 'invitations' ];
	}
}

class QueryFilters {
	static forProjectMembers(
		projectID?: number,
		{ queryType = 'active' }: { queryType?: QueryType } = {}
	): TanstackQueryFilters {
		return {
			predicate: ( { queryKey } ) => (
				Array.isArray( queryKey )
					&& queryKey.length >= 3
					&& queryKey[ 0 ] === 'projects'
					&& ( !projectID || queryKey[ 1 ] === projectID )
					&& queryKey[ 2 ] === 'members'
			),
			type: queryType
		};
	}
}

export { QueryKeys, QueryFilters };
